import React from 'react';
import { motion } from 'framer-motion';

/**
 * Page transition wrapper — fades + slides content in/out on route changes.
 * Wrap each route's element in this for smooth transitions.
 */
const pageVariants = {
  initial: {
    opacity: 0,
    y: 16,
    filter: 'blur(4px)',
  },
  in: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
  },
  out: {
    opacity: 0,
    y: -8,
    filter: 'blur(2px)',
  },
};

const pageTransition = {
  type: 'tween',
  ease: [0.22, 1, 0.36, 1], // Custom ease-out
  duration: 0.4,
};

export default function PageTransition({ children }) {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
}
